module.exports = __webpack_public_path__ + "img/14.3c8ef9e5.jpg";